import { useDispatch, useSelector } from "react-redux";
import { fetchIntegrationById, fetchIntegrations, fetchIntegrationByPracticeId, fetchIntegrationPlatforms } from "../../redux/integration/integrationSlice";
import { useEffect } from "react";
import { RootState } from '../../redux';
import { AppDispatch } from '../../redux';

const useIntegration = () => {
    const dispatch = useDispatch<AppDispatch>();

    const integrationState = useSelector((state: RootState) => state.integration);
    const integrations = integrationState?.integrations || [];
    const loading = integrationState?.isLoading || false;

    useEffect(() => {
        dispatch(fetchIntegrations());
    }, [dispatch]);
    
    return {
        integrations,
        loading
    }
}

const useIntegrationById = (id: string) => {
    const dispatch = useDispatch<AppDispatch>();

    const integrationState = useSelector((state: RootState) => state.integration);
    const integration = integrationState?.integration || null;

    useEffect(() => {
        if (id) {
            dispatch(fetchIntegrationById(id));
        }
    }, [dispatch, id]);

    return {
        integration
    };
}

const useIntegrationsByPracticeId = (practiceId: string) => {
    const dispatch = useDispatch<AppDispatch>();
    const integrationState = useSelector((state: RootState) => state.integration);
    const integration = integrationState?.integration || null;
    const loading = integrationState?.isLoading || false;
    const error = integrationState?.error || null;
    
    
    useEffect(() => {
        if (practiceId) {
            dispatch(fetchIntegrationByPracticeId(practiceId));
        }
    }, [dispatch, practiceId]);

    return {
        integration,
        loading,
        error
    }
}    

const useIntegrationPlatforms = () => {
    const dispatch = useDispatch<AppDispatch>();

    const integrationState = useSelector((state: RootState) => state.integration);
    const platforms = integrationState?.platforms || [];
    const loading = integrationState?.platformsLoading || false;
    const error = integrationState?.platformsError || null;

    useEffect(() => {
        dispatch(fetchIntegrationPlatforms());
    }, [dispatch]);

    return {
        platforms,
        loading,
        error
    }
}

export { useIntegration, useIntegrationById, useIntegrationsByPracticeId, useIntegrationPlatforms };
